import { ContentMimeTypes, downloadFile } from '@/services/DownloadService';
import http from '@/services/HttpService';
import { useState } from 'react';

export function useCertificate() {
    const [loadingCertificate, setLoadingCertificate] = useState<boolean>(false);

    function downloadCertificate(url: string): Promise<any> {
        setLoadingCertificate(true);
        return http
            .get(url, { responseType: 'blob' })
            .then((response) => {
                setLoadingCertificate(false);
                return response;
            })
            .catch((error) => {
                setLoadingCertificate(false);
                return Promise.reject(error);
            });
    }

    function downloadCertificateFile(
        url: string,
        filename: string,
        mimetype: ContentMimeTypes
    ): Promise<any> {
        return downloadCertificate(url).then(
            ({ data }: any) => downloadFile(data, filename, mimetype)
        );
    }

    return {
        loadingCertificate,
        setLoadingCertificate,
        downloadCertificate,
        downloadCertificateFile,
    };
}
